import { Dialog, Button, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import { supabaseGetter } from '~/api/supabase-getter'
import { useDeleteCrop } from '~/api/supabase-mutations'
import { cropRemoved, useCropsContextDispatch } from '~/common/context/crops/crops-context'

// TODO implement
export const DeleteCropModal = ({ cropId, open, onClose }) => {
  const theme = useTheme()
  const cropsDispatch = useCropsContextDispatch()
  const { deleteCrop } = useDeleteCrop()

  const handleDeleteCrop = async () => {
    await deleteCrop(cropId)
    supabaseGetter.crops.invalidate()
    supabaseGetter.cropPhases.invalidate()
    supabaseGetter.cropSchedules.invalidate()
    supabaseGetter.cropDetails.invalidate()
    supabaseGetter.tasks.invalidate()
    cropsDispatch(cropRemoved({ cropId }))
    onClose && onClose()
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack style={{ padding: 24, minWidth: 300 }}>
        <Typography variant="h4" component="h2">
          Delete Crop
        </Typography>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Do you really want to delete this crop? This action
          <strong><span style={{ color: theme.palette.error.main }}> cannot be undone.</span></strong>
        </Typography>

        <Stack direction='row' style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24 }}>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            sx={{
              '&:hover': {
                backgroundColor: theme => theme.palette.primary[200]
              }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCrop}
            color="error"
            variant="contained"
            sx={{
              '&:hover': {
                backgroundColor: theme => theme.palette.error[800]
              }
            }}
          >
            Delete
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}
